module.exports = __webpack_public_path__ + "files/31e5855e0bd3a1b096ac25277a0e4f14.svg";